import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { ChangeEvent, useId } from 'react';
import { ConductorTriggerFormFields, ConductorTriggerType } from './types';
import { FormControlLabel, Grid, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import { FieldValidation } from '@rjsf/utils';

const useStyles = makeStyles(() => ({
  root: {
    borderColor: '#eeeeee',
    borderWidth: 1,
    borderStyle: 'solid',
    maxWidth: 500,
    marginBottom: 10,
    padding: 10,
  },
  container: {
    marginBottom: 2,
  },
  fieldset: {
    border: 0,
    margin: 0,
    minWidth: 0,
    padding: 0,
  },
  legend: {
    padding: 0,
  },
}));

export const conductorTriggerDefaults: ConductorTriggerFormFields = {
  triggerType: undefined,
};

const buildFormDataForTriggerType = (triggerType: ConductorTriggerType): ConductorTriggerFormFields => {
  if (triggerType === 'blob') {
    return {
      triggerType,
      storageAccountName: '',
      containerName: '',
      secretKey: '',
    };
  }

  if (triggerType === 'serviceBus') {
    return {
      triggerType,
      queueName: '',
      secretKey: '',
    };
  }

  return {
    triggerType: 'cron',
    schedule: '',
  };
};

export const ConductorTriggerTypeField = (props: FieldExtensionComponentProps<ConductorTriggerFormFields>) => {
  const classes = useStyles();
  const fieldId = useId();
  const triggerTypeSelected = props.formData?.triggerType ?? '';

  const onTriggerTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedTriggerType = event.target.value as ConductorTriggerType;
    props.onChange(buildFormDataForTriggerType(selectedTriggerType));
  };

  return (
    <Grid container spacing={3} className={classes.root}>
      <Grid item xs={12} className={classes.container}>
        <fieldset className={classes.fieldset}>
          <legend className={classes.legend}>Job Trigger Type</legend>
          <RadioGroup
            name={`conductor-trigger-type-${fieldId}`}
            value={triggerTypeSelected}
            onChange={onTriggerTypeChange}
          >
            <FormControlLabel value="blob" control={<Radio />} label="Blob" />
            <FormControlLabel value="cron" control={<Radio />} label="Cron" />
            <FormControlLabel value="serviceBus" control={<Radio />} label="Service Bus" />
          </RadioGroup>
        </fieldset>
      </Grid>
      {props.formData?.triggerType === 'blob' && (
        <>
          <Grid item xs={12} className={classes.container}>
            <>Check this out no Blob Yet!</>
          </Grid>
        </>
      )}
      {props.formData?.triggerType === 'cron' && (
        <>
          <Grid item xs={12} className={classes.container}>
            <>Check this out no Cron Yet!</>
          </Grid>
        </>
      )}
      {props.formData?.triggerType === 'serviceBus' && (
        <>
          <Grid item xs={12} className={classes.container}>
            <>Check this out no ServiceBus Yet!</>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export const conductorTriggerTypeFieldValidation = (
  value: ConductorTriggerFormFields | null | undefined,
  validation: FieldValidation,
) => {
  if (!value) {
    validation.addError('Trigger Type is required. Please select one.');
    return;
  }

  if (value.triggerType === undefined) {
    validation.addError('Trigger Type is required. Please select one.');
  } else if (value.triggerType === 'blob') {
    validation.addError('Blob triggers are not supported yet.');
  } else if (value.triggerType === 'cron') {
    validation.addError('Cron triggers are not supported yet.');
  } else if (value.triggerType === 'serviceBus') {
    validation.addError('Service Bus triggers are not supported yet.');
  } else {
    validation.addError('Trigger Type is invalid. Please select a supported option.');
  }
};
